import Navbar from "../components/Navbar";
import UrgencyBanner from "../components/UrgencyBanner";
import Hero from "../components/Hero";
import TrustBar from "../components/TrustBar";
import Products from "../components/Products";
import MisoMiniDetails from "../components/MisoMiniDetails";
import HowItWorks from "../components/HowItWorks";
import WhyMiso from "../components/WhyMiso";
import FAQSection from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";
import MobileBar from "../components/MobileBar";

export default function Home() {
  return (
    <div style={{ backgroundColor: '#FAF5EF', overflowX: 'hidden' }}>
      <UrgencyBanner />
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Products />
        <MisoMiniDetails />
        <HowItWorks />
        <WhyMiso />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
